import React, { useEffect } from 'react';
import classNames from 'classnames';
import { useWidgetDndContextData } from 'src/context/WidgetDndContext';
import { useGetDeviceType } from 'src/hooks/useGetDeviceType';
import { DEFAULT_WIDGET_OPTIONS, getBannerImages, getHeight } from '../../utils';
import { useSSRSelector } from 'src/redux';
import { BannerItem } from '../BannerItem';

export default function IntermittentBanner(props) {
  const {
    widgetContextState: { widgets, previewDevice, isBuilder },
  } = useWidgetDndContextData();
  const storeData = useSSRSelector((state) => state.storeReducer.store);
  const { isMobile: isMobileFromServer } = useGetDeviceType();
  const isMobile = isBuilder ? previewDevice === 'mobile' : isMobileFromServer;
  let widgetOptions = props.widgetOptions;

  // When this intermittent banner is used as loader, nothing can be passed as props, thus this was used
  if (!props.widgetOptions) {
    widgetOptions = (
      Object.values(widgets || {}).find(
        (widget: any) => widget.name === 'NewHeroBanner'
      ) as any
    )?.props || { ...DEFAULT_WIDGET_OPTIONS };
  }

  const images = getBannerImages({
    props: { store: storeData, widgetOptions },
    activeWidgetProps: null,
    isDesktop: !isMobile,
  });

  const isNewCarousel = widgetOptions?.forNewCarousel;

  // This need to fix after vacation..
  const height = isNewCarousel
    ? widgetOptions?.[isMobile ? 'heightMobile' : 'height']?.includes?.('px')
      ? widgetOptions?.[isMobile ? 'heightMobile' : 'height']?.split('px')[0]
      : widgetOptions?.[isMobile ? 'heightMobile' : 'height']
    : getHeight(widgetOptions, props?.containerRef?.current?.clientWidth, isNewCarousel);

  const imageToShow = images[0];

  useEffect(() => {
    if (props.setLoadSlider) {
      const timeoutID = setTimeout(() => {
        props.setLoadSlider(true);
      }, 3100);

      return () => {
        clearTimeout(timeoutID);
      };
    }
  }, []);

  if (!imageToShow) return null;
  return (
    <div
      className={classNames(`tw-relative tw-bg-opacity-20`)}
      ref={props.containerRefCallback}
      style={
        isNewCarousel && {
          marginTop:
            widgetOptions?.marginTop + props.adjustedMarginByAnnouncement || '0px',
          marginBottom: widgetOptions?.marginBottom || '0px',
          ...(widgetOptions?.isBannerFullWidth === false
            ? {
                marginLeft: isMobile ? '16px' : '80px',
                marginRight: isMobile ? '16px' : '80px',
              }
            : {}),
        }
      }
    >
      <BannerItem
        image={imageToShow}
        isCurrentSlideActive={true}
        isNewCarousel={isNewCarousel}
        widgetOptions={widgetOptions}
        imageWrapperComponentStyles={
          isNewCarousel
            ? {
                aspectRatio: `${isMobile ? '360' : '1366'}/${height}`,
              }
            : {
                height: height,
                width: props?.containerRef?.current?.clientWidth
                  ? `${props?.containerRef?.current?.clientWidth}px`
                  : '100vw',
              }
        }
        isMobile={isMobile}
      />
    </div>
  );
}
